export default {
  name: 'ExportCheckFileDuplicateModal',
  props: {
    duplicateFileList: {}
  },
}